import type { NoiseFilterState } from '@cli-types/next-adapter/utils.js'
import {
  DRIZZLE_NOISE_PATTERNS,
  NODE_TRACE_WARNING_HINT,
  PG_SSL_WARNING_END,
  PG_SSL_WARNING_START
} from '@cli-constants/process-output.js'
import { stripAnsi } from '@cli-utils/text.js'

export function shouldSuppressOutputLine(line: string, state: NoiseFilterState): boolean {
  const text = stripAnsi(line, { stripCarriageReturns: true }).trim()

  if (state.suppressNextTraceHint) {
    state.suppressNextTraceHint = false
    if (text.startsWith(NODE_TRACE_WARNING_HINT)) {
      return true
    }
  }

  if (text.includes(PG_SSL_WARNING_START)) {
    state.suppressingPgSslWarning = true
    return true
  }

  if (state.suppressingPgSslWarning) {
    if (text.includes(PG_SSL_WARNING_END)) {
      state.suppressingPgSslWarning = false
      state.suppressNextTraceHint = true
    }
    return true
  }

  return DRIZZLE_NOISE_PATTERNS.some((pattern) => pattern.test(text))
}
